/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled from 'styled-components';
import { getUpMedia } from '../styles';

export const TabletDownBr = styled.br`
  ${getUpMedia('md')} {
    display: none;
  }
`;
